<template>
  <div class="">
    <div v-if="value.length > 0">
      <el-row v-for="(item, index) in value" :key="index">
        <el-col :span="10" class="key">
          <el-input v-model="item.key" placeholder="key" />
        </el-col>
        <el-col :span="11" class="value">
          <el-input
            v-if="simpleValueInput"
            v-model="item.value"
            placeholder="value"
          />
          <snippet-input
            v-else
            v-model="item.value"
            placeholder="value"
            :emoji="false"
            :snippets="false"
          />
        </el-col>
        <el-col :span="3">
          <icon
            class="icon delete-btn"
            glyph="bin"
            @click="removeItem(index)"
          />
        </el-col>
      </el-row>
    </div>
    <el-button
      type="primary"
      class="add-payload-btn"
      plain
      icon="el-icon-circle-plus-outline "
      @click="addPayload"
      :disabled="!isAddBtnActive"
      :data-qa="dataQa"
      >{{
        addBtnTitle ? addBtnTitle : $t('CampaignForm_Push_AddPayload')
      }}</el-button
    >
  </div>
</template>

<script>
import SnippetInput from '@/modules/campaign-manage/components/SnippetInput'
import _ from 'lodash'
export default {
  name: 'KeyValueEditor',
  components: { SnippetInput },
  props: {
    value: {
      type: Array,
      required: true
    },
    addBtnTitle: {
      type: String
    },
    simpleValueInput: {
      type: Boolean,
      required: false,
      default: false
    },
    dataQa: {
      type: String,
      required: false
    }
  },
  computed: {
    isAddBtnActive() {
      if (this.value.length === 0) {
        return true
      }
      let last = _.last(this.value)
      return last.key !== '' && last.value !== ''
    }
  },
  methods: {
    removeItem(index) {
      this.$delete(this.value, index)
    },
    addPayload() {
      this.value.push({ key: '', value: '' })
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  margin-bottom: 10px;
}
.el-row {
  margin: 10px 0px !important;
}
>>> .el-button {
  line-height: 24px;
}
>>> .el-input-group__append .el-button {
  line-height: 23px;
  padding: inherit !important;
  margin: 0 2px;
}
>>> .el-input-group__append {
  padding: 0 7px;
}

>>> .dropdown-btn {
  width: inherit !important;
  height: inherit !important;
}
.key {
  padding-left: 0px !important;
}
.value {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
>>> .value .el-input__inner {
  padding: 7px;
}
.delete-btn {
  font-size: 1.5em;
  vertical-align: middle;
  cursor: pointer;
  color: #cdd0d7;
  line-height: 34px;
  float: right;
  height: 40px;
}
.add-payload-btn {
  line-height: inherit !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/KeyValueEditor.vue